/* @flow */
import { takeLatest, takeEvery, fork, put, call, all } from 'redux-saga/effects'
import { success, warning, error, info } from 'react-notification-system-redux'
import { I18n } from 'react-redux-i18n'
import { replace } from 'react-router-redux'
import _ from 'lodash'
import moment from 'moment'

import {
  GET_RESOURCES,
  GET_ANNOUNCEMENTS,
  GET_HOME_RESOURCES,
  GET_HOME_SLIDES,
  GET_HOME_SLIDES_SUCCESS,
  GET_HOME_SLIDES_FAILURE,
  // GET_SCENES,
  // GET_SHOPS,
  HIDE_LOGIN,
  LOGIN,
  INIT_AUTH,
  LOGIN_SUCCESS,
  // LOGIN_FAILURE,
  LOGOUT,
  LOGOUT_SUCCESS,
  // LOGOUT_FAILURE,
  TO_REGISTER,
  REGISTER,
  // REGISTER_SUCCESS,
  SEARCH_SCENE,
  SEARCH_SHOP,
  SEARCH,
  UPDATE_ACCOUNT,
  UPDATE_ACCOUNT_PROFILE_SUCCESS,
  FORGOT_PASSWORD,
  SEND_MESSAGE,
  GET_MESSAGES_SUCCESS,
  GET_MESSAGES,
  GET_SCENES,
  GET_SHOPS,
  GET_ACTIVITIES,
  GET_CATEGORIES,
} from '../configs/constants'
import API from '../libs/api'
import { hideMessageModal, getMessages, updateLocalAnnouncements, getCategories, updateCategoriesState } from '../actions/global'
import { getDiscounts, getAccountCoupons } from '../actions/discount'

const api = new API()

/* Workers */
export function* initAuth() {
  try {
    const user = yield call([api, api.initAuth])
    if (user) {
      let profile = yield call([api, api.readDBOnce], '/accounts/' + user.uid)
      const now = new Date().getTime()
      if (!profile) { // It must be the account provided by 3rd-party
        // We should create the profile
        profile = {
          uid: user.uid,
          role: 'user',
          displayName: user.displayName,
          email: user.email,
          emailVerified: user.emailVerified,
          phoneNumber: user.phoneNumber,
          photoURL: user.photoURL,
          createdTime: now,
          lastSignin: now,
          providerId: user.providerData[0].providerId,
        }
        yield call([api, api.writeDB], '/accounts/' + user.uid, profile)
      } else {
        // Update 'lastSignin'
        profile.lastSignin = now
        if (user.emailVerified && !profile.emailVerified) {
          profile.emailVerified = true
        }
        yield call([api, api.updateDB], '/accounts/' + user.uid, profile)
      }

      yield put(success({ message: 'Login successfully' }))
      yield put({ type: LOGIN_SUCCESS, user: profile })
      yield all([
        put(getMessages(profile.displayName, user.email)),
        put(getAccountCoupons(user.uid)),
      ])
    } else {
      console.error('not login')
      // yield put(error({ message: 'Login failed' }))
    }
  } catch (err) {
    yield put(error({ title: 'Error ' + err.code, message: err.message }))
  }
}

export function* fetchResources(action) {
  yield all([
    put({ type: GET_SCENES }),
    put({ type: GET_SHOPS }),
    put({ type: GET_ACTIVITIES }),
    put(getDiscounts()),
  ])
}
export function* fetchHomeResources() {
  yield all([
    // put({ type: GET_SCENES }),
    // put({ type: GET_SHOPS }),
    put({ type: GET_HOME_SLIDES }),
    put({ type: GET_ANNOUNCEMENTS }),
    put(getCategories()),
  ])
}
export function* fetchHomeSlides() {
  try {
    const slides = yield api.readDBOnce('/slides')
    for (let slide of slides) {
      slide.url = yield call([api, api.getStorageUrl], slide.url)
    }
    yield put({ type: GET_HOME_SLIDES_SUCCESS, slides: slides })
  } catch (error) {
    yield put({ type: GET_HOME_SLIDES_FAILURE, error })
  }
}
export function* fetchAnnouncements() {
  try {
    const announcements = yield call([api, api.readDBOnce], '/announcements')
    const now = moment()
    const activeList = _.filter(announcements,
      (announce) => now.isAfter(moment(announce.startDate)) && now.isBefore(moment(announce.endDate))
    )
    yield put(updateLocalAnnouncements(activeList))
  } catch (err) {
    yield put(error({ title: 'Error ' + err.code, message: err.message }))
  }
}
export function* fetchCategories() {
  try {
    const categories = yield call([api, api.readDBOnce], '/categories')
    yield put(updateCategoriesState(categories))
  } catch (err) {
    yield put(error({ title: 'Error ' + err.code, message: err.message }))
  }
}

export function* login({ type, params = {} }) {
  try {
    const user = yield call([api, api.login], params)
    if (user.warn) {
      yield put(warning({ message: user.warn }))      
    } else {
      const profile = yield call([api, api.readDBOnce], '/accounts/' + user.uid)      
      yield put(success({ message: I18n.t('loginSuccess') }))
      yield put({ type: LOGIN_SUCCESS, user: { ...user, profile } })
    }
  } catch (err) {
    console.error('login failed: ', err)
    // yield put({ type: LOGIN_FAILURE, error })
    yield put(error({ title: 'Error ' + err.code, message: err.message }))
    if (err.code === 'auth/user-not-found') {
      //
      yield put({ type: TO_REGISTER, registerInfo: params })
    }
  }
}

export function* register({ type, params = {} }) {
  try {
    const user = yield call([api, api.signup], params)
    if (user) {
      // Initialize profile
      const now = new Date().getTime()
      yield call([api, api.writeDB], '/accounts/' + user.uid, {
        uid: user.uid,
        role: 'user',
        email: user.email,
        emailVerified: false,
        createdTime: now,
        lastSignin: now,
        providerId: 'email',
        displayName: user.email.substring(0, user.email.indexOf('@')),
      })
      yield call([user, user.sendEmailVerification])
      yield put(success({ message: 'Email verification has been sent' }))
      yield put({ type: HIDE_LOGIN })
    }
  } catch (err) {
    yield put(error({ message: 'Registration failed: :' + err }))
  }
}

export function* resetPassword({ type, email }) {
  try {
    yield call(api.resetPassword, email)
    yield put(success({ message: I18n.t('resetPasswordSent') }))
  } catch (err) {
    yield put(error({ title: err.code, message: err.message }))
  }
}

export function* logout() {
  try {
    const result = yield call([api, api.logout])
    sessionStorage.clear()
    yield put({ type: LOGOUT_SUCCESS, result })
    yield put(replace('/'))
    yield put(success({ message: I18n.t('logoutSuccess') }))
  } catch (err) {
    yield put(error({ title: 'Error: ' + err.code, message: err.message }))
  }
}

export function* updateAccount({ type, profile }) {
  try {
    const now = new Date()
    yield call([api, api.updateDB], '/accounts/' + profile.uid, { ...profile, updatedTime: now.getTime() })
    yield put({ type: UPDATE_ACCOUNT_PROFILE_SUCCESS, profile })
    yield put(success({ message: I18n.t('updateAccountSuccess') }))
  } catch (err) {
    yield put(error({ title: 'Error: ' + err.code, message: err.message }))
  }
}

export function* search({ type, payload }) {
  try {
    yield put({ type: SEARCH_SCENE, payload })
    yield put({ type: SEARCH_SHOP, payload })
  } catch (err) {
    yield put(error({ title: 'Error Searching', message: err }))
  }
}

export function* fetchMessages({ type, payload }) {
  try {
    const messages = yield call([api, api.readDBOnce], '/messages')
    const unread = _.filter(messages, { status: 'unread' })
    if (unread.length) {
      yield put(info({ title: I18n.t('youHaveNewMessages'), message: I18n.t('plzGotoAccountToSeeIt') }))
    }
    yield put({
      type: GET_MESSAGES_SUCCESS,
      messages: _.sortBy(
        _.filter(
          messages, (message) => {
            const isUserCreated = message.creator === payload.displayName && message.type !== 'system'
            const isReceived = message.creator !== payload.displayName
            return message.email === payload.email && (isUserCreated || isReceived)
          }
        ),
        ['created_at']
      )
    })
  } catch (err) {
    yield put(error({ title: I18n.t('getMessageFailed'), message: err.message }))
  }
}

export function* sendMessage({ type, payload }) {
  try {
    yield call([api, api.pushDB], '/messages', { ...payload, created_at: new Date().getTime(), status: 'read' })
    yield put(success({ message: I18n.t('sendMessageSuccess') }))
    yield put(hideMessageModal())
  } catch (err) {
    yield put(error({ title: I18n.t('sendMessageFailed') + ': ' + err.code, message: err.message }))
  }
}

/* Watchers */
function* initAuthWatcher() {
  yield takeLatest(INIT_AUTH, initAuth)
}
function* homeResourcesWatcher() {
  yield takeLatest(GET_HOME_RESOURCES, fetchHomeResources)
}
function* getResourcesWatcher() {
  yield takeLatest(GET_RESOURCES, fetchResources)
}
function* slideWatcher() {
  yield takeLatest(GET_HOME_SLIDES, fetchHomeSlides)
}
function* getAnnouncementWatcher() {
  yield takeLatest(GET_ANNOUNCEMENTS, fetchAnnouncements)
}
function* getCategoriesWatcher() {
  yield takeLatest(GET_CATEGORIES, fetchCategories)
}
function* loginWatcher() {
  yield takeLatest(LOGIN, login)
}
function* registerWatcher() {
  yield takeLatest(REGISTER, register)
}
function* forgotPasswordWatcher() {
  yield takeLatest(FORGOT_PASSWORD, resetPassword)
}
function* logoutWatcher() {
  yield takeLatest(LOGOUT, logout)
}
function* updateAccountWatcher() {
  yield takeLatest(UPDATE_ACCOUNT, updateAccount)
}
function* searchWatcher() {
  yield takeLatest(SEARCH, search)
}
function* fetchMessagesWatcher() {
  yield takeLatest(GET_MESSAGES, fetchMessages)
}
function* sendMessageWatcher() {
  yield takeEvery(SEND_MESSAGE, sendMessage)
}

export default [
  fork(initAuthWatcher),
  fork(homeResourcesWatcher),
  fork(getAnnouncementWatcher),
  fork(getCategoriesWatcher),
  fork(getResourcesWatcher),
  fork(slideWatcher),
  fork(loginWatcher),
  fork(registerWatcher),
  fork(forgotPasswordWatcher),
  fork(logoutWatcher),
  fork(updateAccountWatcher),
  fork(searchWatcher),
  fork(fetchMessagesWatcher),
  fork(sendMessageWatcher),
]


// WEBPACK FOOTER //
// ./src/sagas/globalSaga.js